import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getProductsQuery = gql`
  query products($breweryId: Int!) {
    products(breweryId: $breweryId) {
      id
      name
    }
  }
`;

const ProductOptions = ({ brewery }) => (
  <Query query={getProductsQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the products</option>;
      }

      return (
        <Fragment>
          <option value="">Select a product</option>
          {data.products.map(product => (
            <option key={product.id} value={product.id}>
              {product.name}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(ProductOptions);



// WEBPACK FOOTER //
// ./src/containers/productOptions/productOptions.jsx